import { useState, useEffect } from "react";
import { Container, Row, Col, Spinner, ProgressBar } from "react-bootstrap";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import CardContainer from "../components/CardContainer";
import { Link } from "react-router-dom";
import { apiFetch } from "../api";

const defaultImages = [
  {
    id: 1,
    src: "https://captionstags.com/wp-content/uploads/2024/05/traditional-kurti-captions-for-instagram.webp",
  },
];

const Home = (props) => {
  const { searchQuery = "" } = props;
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [carouselImages, setCarouselImages] = useState(defaultImages);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  async function fetchProductData() {
    setLoading(true);
    
    try {
      const data = await apiFetch("/api/products/all");
      setProducts(data.data || []);
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]);
    }
    setLoading(false);
  }

  async function fetchCarouselData() {
    
    // api= /api/carousel/all
    try {
      const data = await apiFetch("");
      // console.log("Carousel data:", data);
      if (data.success && data.data && data.data.length >= 2) {
        setCarouselImages(
          data.data.map((src, idx) => ({ id: idx + 1, src }))
        );
      }
    } catch (error) {
      // console.error("Error fetching carousel:", error);
    }
  }

  useEffect(() => {
    fetchProductData();
    fetchCarouselData();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [carouselImages.length]);

  // Group products by category
  const groupedProducts = products.reduce((acc, product) => {
    const category = product.category?.name || "Uncategorized";
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(product);
    return acc;
  }, {});

  // Filter products by search query
  const filterBySearch = (products) => {
    if (!searchQuery) return products;
    return products.filter((product) =>
      product.name.toLowerCase().includes(searchQuery.toLowerCase().trim())
    );
  };

  const handleShowMore = (category) => {
    navigate(`/products?category=${encodeURIComponent(category)}`);
  };

  return (
    <>
      <div className="mask flex-center">
        <Container>
          <Row className="align-items-center">
            <Col
              md={7}
              xs={12}
              className="order-md-1 order-2"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <span className="carousel-title display-4">
                <strong>
                  <span style={{ color: "#82278A" }}>Welcome to Label-</span>{" "}
                  <br />
                  Aadvi{" "}
                </strong>
              </span>
              <p className="mt-2">
                Best Quality Fabrics - Classy Designs - Affordable Pricing
              </p>
              <div className="home-btn">
              <Link
                to="/products"
                className="btn img-btn p-3 "
                data-aos="zoom-in"
                data-aos-delay="400"
              >
                Shop Collection
              </Link>
              </div>
            </Col>
            <Col
              md={5}
              xs={12}
              className="order-md-2 order-1"
              data-aos="fade-left"
              data-aos-delay="300"
            >
              <div
                className="image-slider"
                style={{
                  overflow: "hidden",
                  position: "relative",
                  width: "100%",
                  height: "400px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >

                  {carouselImages.map((img, index) => (

                      <img
                        src={img.src}
                        className="img-fluid"
                        alt={`slide${img.id}`}
                        style={{
                          width: "90%",
                          height: "90%",
                          objectFit: "cover",
                          objectPosition: "center",
                          
                        }}
                      />
                    
                  ))}
                
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Product Sections */}
      {loading ? (
        <div className="text-center py-5 w-100">
          <div className="text-center">
            <Spinner animation="border" className="loading-spinner" style={{ color: "#82278A", width: '3rem', height: '3rem' }} />
            <div className="mt-3">
              <p className="text-purple mb-2">Loading products...</p>
              <ProgressBar 
                now={100} 
                animated 
                style={{ height: '4px', width: '200px', margin: '0 auto' }}
                variant="purple"
              />
            </div>
          </div>
        </div>
      ) : (
        Object.keys(groupedProducts).map((category) => {
          const categoryProducts = filterBySearch(groupedProducts[category]);
          const slicedProducts = categoryProducts.slice(0, 8);
          const hasMore = categoryProducts.length > 8;
          if (slicedProducts.length === 0) return null; 
          return (
            <div key={category} id="card-container-section">
              <CardContainer
                posts={slicedProducts}
                loading={loading}
                title={category}
              />
              {hasMore && (
                <div style={{ textAlign: "center", margin: "20px 0" }}>
                  <button
                    className="btn img-btn p-3"
                    onClick={() => handleShowMore(category)}
                  >
                    Show More
                  </button>
                </div>
              )}
            </div>
          );
        })
      )}
    </>
  );
};

export default Home;